import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {
    ObjectSubBaseComponent
} from "../../../../../../cr/component/protected-components/cr-customer/component/object-sub-base.component";
import {DmDocumentViewOptionsEnumEnum} from "../../../../../../../feature-core/dm/enum/dm-document-view-options.enum";

// NOT_IN_USE
@Component({
    selector: 'cm-contract-documents-navigation',
    templateUrl: './cm-contract-documents-navigation.component.html',
    standalone: false
})
export class CmContractDocumentsNavigationComponent extends ObjectSubBaseComponent implements OnInit, OnChanges, OnDestroy {
    dmDocumentViewOptionsEnumEnum = DmDocumentViewOptionsEnumEnum;

    ngOnInit(): void {
        this.initComponent();
    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.refreshWidgets();
        this.initialized = true;
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["objectIdentifier"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }

    refreshWidgets() {
    }



}
